// features/campaign.constants.js

export const CAMPAIGN_STATUS_STYLE = {
  DRAFT:     { bg: "bg-surface_alt", text: "text-text_secondary", border: "border-border" },
  SCHEDULED: { bg: "bg-info_bg",     text: "text-info",           border: "border-info_border" },
  QUEUED:    { bg: "bg-warning_bg",  text: "text-warning",        border: "border-warning_border" },
  SENDING:   { bg: "bg-primary_tint", text: "text-primary",       border: "border-primary/20" },
  PAUSED:    { bg: "bg-high_bg",     text: "text-high",           border: "border-high_border" },
  SENT:      { bg: "bg-success_bg",  text: "text-success",        border: "border-success_border" },
  FAILED:    { bg: "bg-danger_bg",   text: "text-danger",         border: "border-danger_border" },
};

export const CAMPAIGN_STATUS_LABEL = {
  DRAFT: "Draft",
  SCHEDULED: "Scheduled",
  QUEUED: "Queued",
  SENDING: "Sending",
  PAUSED: "Paused",
  SENT: "Sent",
  FAILED: "Failed",
};

export const CAMPAIGN_TYPE_OPTIONS = [
  { value: "MARKETING", label: "Marketing Email" },
];

export const ROLE_OPTIONS = [
  { value: "CLIENT", label: "Client" },
  { value: "ADMIN", label: "Admin" },
  { value: "EMPLOYEE", label: "Employee" },
];

export const LOGIN_FILTER_OPTIONS = [
  { value: "ANY", label: "Any time" },
  { value: "NEVER", label: "Never logged in" },
  { value: "LAST_7_DAYS", label: "Last 7 days" },
  { value: "LAST_30_DAYS", label: "Last 30 days" },
  { value: "LAST_90_DAYS", label: "Last 90 days" },
  { value: "CUSTOM_RANGE", label: "Custom range" },
];

export const IN_PROGRESS_STATUSES = ["QUEUED", "SENDING", "SCHEDULED"];
